<template>
    <BaseAvatar :size="size" :disabled="disabled || !available" class="profile-avatar">
        <span v-if="initials" class="initial" :class="{ 'is-compact': isCompact }">{{ initials }}</span>
        <i v-else class="bi bi-person" aria-hidden="true" />
    </BaseAvatar>
</template>

<script setup lang="ts">
import BaseAvatar, { type BaseAvatarSize } from "~vue/components/BaseAvatar.vue";
import { getAvatarInitials } from "~vue/utils/avatarUtils";
import { computed } from "vue";

const {
    name,
    size = "md",
    available = true,
    disabled = false,
} = defineProps<{
    name?: string | null;
    size?: BaseAvatarSize;
    available?: boolean;
    disabled?: boolean;
}>();

const isCompact = computed(() => size === "xs" || size === "sm");
const initials = computed(() => {
    const full = getAvatarInitials(name);
    return isCompact.value ? full.charAt(0) : full;
});
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .initial {
        @apply body-serif;
    }

    /* Compact circles fit only a single initial, at the original smaller step. */
    .initial.is-compact {
        @apply font-bold text-[11px] leading-none;
    }

    .profile-avatar {
        --base-avatar-bg: var(--color-avatar-profile-bg);
        --base-avatar-text: var(--color-ink-inverse);
    }
}
</style>
